import { CommonModule } from '@angular/common';
import { Component, ViewChild, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

import { SharedPipesModule } from 'src/pipes/shared-pipes.module';
import { AuthService } from 'src/services/auth.service';

import { KnowledgeBaseArticlesComponent } from './knowledge-base-articles-table/knowledge-base-articles.component';
import { KnowledgeBaseScrapeJobsComponent } from './knowledge-base-scrape-jobs/knowledge-base-scrape-jobs.component';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    NgxDatatableModule,
    SharedPipesModule,
    KnowledgeBaseArticlesComponent,
    RouterModule,
    KnowledgeBaseScrapeJobsComponent,
  ],
  selector: 'app-knowledge-base',
  templateUrl: './knowledge-base.component.html',
  styleUrls: ['./knowledge-base.component.scss'],
})
export class KnowledgeBaseComponent implements OnInit {
  @ViewChild('articles') articles: KnowledgeBaseArticlesComponent;
  @ViewChild('jobs') jobs: KnowledgeBaseScrapeJobsComponent;

  constructor(public authService: AuthService) {}

  ngOnInit() {
    return;
  }
}
